import { SimIcon } from './SimIcon';

/**
 * author: Google
 * id 93020F21-A0FE-427D-8685-B74EE39B9921
 * name sim
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sim.svg
 * tags
 * - Cellphone / Phone 
 */
export const SubscriberIdentificationModuleIcon = SimIcon;
export default SubscriberIdentificationModuleIcon